const config = {
  apiUrl: " https://api.rmscenariobuilder.com"
  // apiUrl: "http://localhost:3001"
};

export default config;
